import { never } from "@vendrinc/frontend-ts";
import { z } from "zod";
import { Sku } from "../backoffice/client";

export type RequestType = "PriceCheck" | "PriceEstimate";

export enum RequestTypeParam {
  PriceCheck = "priceCheck",
  PriceEstimate = "priceEstimate",
}

export const RequestTypeParamSchema = z.union([
  z.nativeEnum(RequestTypeParam),
  z.null(),
]);

export const toRequestType = (value: RequestTypeParam) => {
  switch (value) {
    case RequestTypeParam.PriceCheck:
      return "PriceCheck";

    case RequestTypeParam.PriceEstimate:
      return "PriceEstimate";

    default:
      return never(value);
  }
};

export const getSelectedSku = ({
  selectedProductId,
  selectedTierId,
  skus,
}: {
  selectedProductId?: string | null;
  selectedTierId?: string | null;
  skus: Sku[];
}) =>
  // Note: tierId no longer exists in the backoffice Sku schema
  skus?.find((s) => (s as { tierId?: string }).tierId === selectedTierId) ||
  skus?.find((s) => s.productId === selectedProductId);

export const getBillingUnits = (sku: Sku) =>
  sku?.pricingUnitLabel?.toLowerCase();

export type RequestTypeDeprecated =
  | "price_check"
  | "quote"
  | "price_estimate"
  | "price_estimate_v2";
